export default __webpack_public_path__ + "static/media/pageNotFound.a7f51029.svg";